<template>
  <div class="survey-error-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block has-text-centered">
                <div class="icon-wrapper error">
                  <b-icon
                    icon="alert-circle"
                    size="is-large"
                    type="is-danger"
                  />
                </div>
                <h1
                  class="title is-spaced is-size-2-desktop is-size-4-mobile has-text-weight-semibold mt-4 mb-2"
                >
                  Error al Cargar la Encuesta
                </h1>
                <p
                  class="subtitle is-size-5-desktop is-size-6-mobile has-text-grey"
                >
                  Lo sentimos, ha ocurrido un error al intentar recuperar la
                  encuesta.
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content has-text-centered">
                <p
                  class="is-size-7 has-text-grey mb-4"
                  style="line-height: 1.6;"
                >
                  Por favor, verifica tu conexión a internet e intenta
                  nuevamente. Si el problema persiste, contacta al administrador
                  del sistema.
                </p>

                <b-button
                  v-if="showRetryButton"
                  type="is-primary"
                  size="is-medium"
                  expanded
                  @click="handleRetry"
                >
                  Intentar Nuevamente
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyError",
  props: {
    showRetryButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleRetry() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped>
.survey-error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(245, 245, 245, 0.5);
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 2rem 1.5rem 1.5rem;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.icon-wrapper.error {
  background-color: rgba(241, 70, 104, 0.1);
}

.card-content {
  padding: 1rem 1.5rem 1.5rem;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .survey-error-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1.5rem 1rem 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .icon-wrapper {
    width: 3.5rem;
    height: 3.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/SurveyError.vue